import { BrowserRouter, Route, Routes } from "react-router-dom";
import Navbar from "../components/Navbar";
import { AuthContextProvider } from "../context/AuthContext";
import { PresenceContextProvider } from "../context/PresenceContext";
import App from "./App";
import Chat from "./Chat";
import LikedNamesPage from "./LikedNamesPage";

import Admin from "./Admin";
import AdminDataSources from "./AdminDataSources";
import AdminInfrastructure from "./AdminInfrastructure";
import AdminProcesses from "./AdminProcesses";
import AdminUsers from "./AdminUsers";
import Project from "./Project";
import Projects from "./Projects";
import Scrapers from "./Scrapers";
import ServicePage from "./ServicePage";
import StatsPage from "./StatsPage";

import DynamicIcon from "../components/DynamicIcon";
import PrivateRoute from "../components/PrivateRoute"; // Import the PrivateRoute component
import Form from "./Form";
import Name from "./Name";
import NotFoundPage from "./NotFoundPage";
import Process from "./Process";
import SignIn from "./SignIn";
import StyleGuide from "./StyleGuide";
import Visual from "./Visual";

const Router = () => (
  <BrowserRouter>
    <AuthContextProvider>
      <PresenceContextProvider>
        <DynamicIcon />
        <div style={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
          <Routes>
          <Route path="/" element={<App />} />
          <Route path="/style-guide" element={<StyleGuide />} />
          <Route path="/signin" element={<SignInWithNavbar />} />
          <Route path="/app" element={<PrivateRoute element={<WithNavbar element={<App />} />} />} />
          <Route path="/projects/new" element={<PrivateRoute element={<WithNavbar element={<Form />} />} />} />
          <Route path="/projects/:projectId/edit" element={<PrivateRoute element={<WithNavbar element={<Form />} />} />} />
          <Route path="/visual" element={<PrivateRoute element={<WithNavbar element={<Visual />} />} />} />
          <Route path="/trademarking" element={<PrivateRoute element={<WithNavbar element={<Scrapers />} />} />} />
          <Route path="/projects" element={<PrivateRoute element={<WithNavbar element={<Projects />} />} />} />
          <Route path="/admin" element={<PrivateRoute element={<WithNavbar element={<Admin />} />} />} />
          <Route path="/admin/users" element={<PrivateRoute element={<WithNavbar element={<AdminUsers />} />} />} />
          <Route path="/admin/processes" element={<PrivateRoute element={<WithNavbar element={<AdminProcesses />} />} />} />
          <Route path="/admin/infrastructure" element={<PrivateRoute element={<WithNavbar element={<AdminInfrastructure />} />} />} />
          <Route path="/admin/data-sources" element={<PrivateRoute element={<WithNavbar element={<AdminDataSources />} />} />} />
          <Route
            path="/scrapers/service"
            element={<PrivateRoute element={<WithNavbar element={<ServicePage />} />} />}
          />
          <Route path="/404" element={<WithNavbar element={<NotFoundPage />} />} />
          <Route
            path="/projects/:projectId"
            element={<PrivateRoute element={<WithNavbar element={<Project />} />} />}
          />
          <Route
            path="/projects/:projectId/names/:nameId"
            element={<PrivateRoute element={<WithNavbar element={<Name />} />} />}
          />
          <Route
            path="/projects/:projectId/stats"
            element={<PrivateRoute element={<WithNavbar element={<StatsPage />} />} />}
          />
          <Route path="/liked-names" element={<PrivateRoute element={<WithNavbar element={<LikedNamesPage />} />} />} />
          <Route
            path="/processes/:processName"
            element={<PrivateRoute element={<WithNavbar element={<Process />} />} />}
          />
          <Route path="/chat" element={<PrivateRoute element={<Chat />} />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
        </div>
      </PresenceContextProvider>
    </AuthContextProvider>
  </BrowserRouter>
);

const SignInWithNavbar = () => (
  <>
    <SignIn />
  </>
);

const WithNavbar = ({ element }) => (
  <>
    <Navbar />
    <div style={{ flex: 1 }}>{element}</div>
  </>
);

export default Router;
